module.exports = __webpack_public_path__ + "static/media/billing-total-cost.6dee312c.svg";